export default {
  multiCall: '0x1Ee38d535d541c55C9dae27B12edf090C608E6Fb',
  wvp: '0x44a9cE69eF2a71A9630697CA5CaB3f4aDaF8f90d',
  wav: '0x888888883BF208d3b1AcD0052a88b9Fd07bA5851',
  tgwNft: '0x888888888C15c2B4285124Ec942E0D76fD4f4BF1',
  tgwVault: '0x8888888818b6e5BBdF1F73c5F3A7F73b2454d2cA',
  acs: '0x4197C6EF3879a08cD51e5560da5064B773aa1d29'
};
